import { PermissionType } from '../../PermissionType'

export const SuperAdminToolPermissions: PermissionType[] = [
  // Realize permissions
  PermissionType.WRITE_ANY_DATASET,
  PermissionType.DELETE_ANY_DATASET,
  PermissionType.POST_ANY_DATASET_POINTS,
  PermissionType.POST_ANY_DATASET_HEATMAP_POINTS,
  PermissionType.LIST_ANY_DATASET_HEATMAP_POINTS,
  PermissionType.LIST_ANY_DATASET_POINTS,
  PermissionType.LIST_ANY_DATASET_POLYGON,
  PermissionType.POST_ANY_DATASET_POLYGON,
  PermissionType.GET_ANY_DATASET,

  // Mobile app permissions
  PermissionType.GET_ANY_MOBILE_APP,
  PermissionType.LIST_ANY_MOBILE_APP,
  PermissionType.WRITE_ANY_MOBILE_APP,
  PermissionType.DELETE_ANY_MOBILE_APP,
  PermissionType.POST_ANY_MOBILE_APP_ORGANIZATION,
  PermissionType.DELETE_ANY_MOBILE_APP_ORGANIZATION,
  PermissionType.POST_UPLOAD_PHOTO,

  // Mobile app release permissions
  PermissionType.GET_ANY_MOBILE_APP_RELEASE,
  PermissionType.WRITE_ANY_MOBILE_APP_RELEASE,
  PermissionType.DELETE_ANY_MOBILE_APP_RELEASE,

  // Billing account permissions
  PermissionType.GET_ANY_BILLING_ACCOUNT,
  PermissionType.LIST_ANY_BILLING_ACCOUNT,
  PermissionType.WRITE_ANY_BILLING_ACCOUNT,
  PermissionType.DELETE_ANY_BILLING_ACCOUNT,
  PermissionType.GET_ANY_BILLING_ACCOUNT_ASSIGNMENT,
  PermissionType.POST_ANY_BILLING_ACCOUNT_ASSIGNMENT,
  PermissionType.DELETE_ANY_BILLING_ACCOUNT_ASSIGNMENT,

  // Nylas Organization Grant permissions
  PermissionType.GET_ANY_NYLAS_ORGANIZATION_GRANT,
  PermissionType.WRITE_ANY_NYLAS_ORGANIZATION_GRANT,

  // Simcity permissions
  PermissionType.GET_ANY_SIMCITY_SIMULATION,
  PermissionType.POST_ANY_SIMCITY_SIMULATION,
  PermissionType.PUT_ANY_SIMCITY_SIMULATION,
  PermissionType.DELETE_ANY_SIMCITY_SIMULATION,
  PermissionType.RESET_ANY_SIMCITY_SIMULATION,

  PermissionType.GET_ANY_DAILY_REQUEST_COUNTS,

  PermissionType.GET_ANY_REPORT,
  PermissionType.PATCH_ANY_REPORT,
  PermissionType.GET_ANY_REPORT_PREVIEW,

  PermissionType.LIST_ANY_GTFS_FILES,

  PermissionType.ROOT_ADMIN_ONLY,

  PermissionType.GET_GTFS_DATASET,
  PermissionType.POST_GTFS_DATASET,
  PermissionType.LIST_GTFS_DATASET,
  PermissionType.PATCH_GTFS_DATASET,

  PermissionType.GET_GTFS_GRAPH,
  PermissionType.POST_GTFS_GRAPH,
  PermissionType.PATCH_GTFS_GRAPH,
  PermissionType.LIST_GTFS_GRAPH,
  PermissionType.WRITE_ORGANIZATION_GRAPH,
  PermissionType.GET_ORGANIZATION_GRAPH,
  PermissionType.DELETE_ORGANIZATION_GRAPH,
  PermissionType.GET_ANY_GTFS_REALTIME_DATASET_VEHICLE_POSITIONS,

  PermissionType.CREATE_ANY_DIRECTORY_SYNC_MAPPING,
  PermissionType.DELETE_ANY_DIRECTORY_SYNC_MAPPING,

  // This permission allows our partner success personnel help setup SSO for new domains
  PermissionType.GENERATE_WORKOS_ADMIN_PORTAL_LINK,

  PermissionType.GET_ANY_EDI_BROKER_CONFIGURATION,
  PermissionType.WRITE_ANY_EDI_BROKER_CONFIGURATION,
]

export const SuperAdminOrganizationPermissions = {
  viewAny: [
    PermissionType.GET_ANY_ORGANIZATION,
    PermissionType.LIST_ANY_ORGANIZATION,
    PermissionType.GET_ANY_ORGANIZATION_CONFIGURATION,
    PermissionType.GET_ANY_ORGANIZATION_BACKUP_SETTINGS,
    PermissionType.GET_ANY_ORGANIZATION_SUPER_ADMIN,
  ],
  manageOwn: [
    PermissionType.PATCH_OWN_ORGANIZATION,
    PermissionType.PATCH_OWN_ORGANIZATION_CONFIGURATION,
    PermissionType.PATCH_OWN_ORGANIZATION_BACKUP_SETTINGS,
    PermissionType.PATCH_OWN_ORGANIZATION_NOTIFICATION_PROVIDERS,
    PermissionType.POST_OWN_ORGANIZATION_SUPER_ADMIN,
    PermissionType.DELETE_OWN_ORGANIZATION_SUPER_ADMIN,
    PermissionType.JOIN_OWN_ORGANIZATION,
    // Manage the organization's connection to Twilio
    PermissionType.WRITE_ANY_TWILIO_CONNECTION,
  ],
  manageAny: [
    PermissionType.PATCH_ANY_ORGANIZATION,
    PermissionType.PATCH_ANY_ORGANIZATION_CONFIGURATION,
    PermissionType.PATCH_ANY_ORGANIZATION_BACKUP_SETTINGS,
    PermissionType.POST_ANY_ORGANIZATION_SUPER_ADMIN,
    PermissionType.DELETE_ANY_ORGANIZATION_SUPER_ADMIN,
    PermissionType.JOIN_ANY_ORGANIZATION,
    PermissionType.PATCH_ANY_ORGANIZATION_NOTIFICATION_PROVIDERS,
    PermissionType.DELETE_ANY_ORGANIZATION,
    PermissionType.IMPORT_ANY_FEATURE_FLAG,
    PermissionType.POST_ANY_DATA_MIGRATION,
  ],
  createAny: [PermissionType.POST_ANY_ORGANIZATION],
}

export const SuperAdminPermissions = {
  view: [
    PermissionType.GET_SUPER_ADMIN,
    PermissionType.LIST_SUPER_ADMIN,
    PermissionType.GET_SUPER_ADMIN_AUTHORIZATION_GROUP,
    PermissionType.GET_SUPER_ADMIN_AUTHORIZATION_ROLE,
  ],
  manage: [
    PermissionType.WRITE_SUPER_ADMIN,
    PermissionType.DELETE_SUPER_ADMIN,
    PermissionType.UPDATE_SUPER_ADMIN_USER_AUTHORIZATION_GROUP,
    PermissionType.UPDATE_SUPER_ADMIN_USER_AUTHORIZATION_ROLE,
  ],
}
